export const violet = {
  190: '#0C0317',
  175: '#1E073A',
  150: '#3C0F74',
  125: '#5A16AE',
  100: '#781DE8',
  75: '#9A56EE',
  50: '#BB8EF3',
  25: '#DDC6F9',
  15: '#e8d4ff',
  10: '#F1E8FD',
  5: '#f5f1ff',
  2: '#f9f5ff',
};

export type VioletVariants = keyof typeof violet;
